import CourseSchedulingScreen from './containers/courseSchedulingScreen'

export {default as CourseSchedulingScreenLayout} from './components/courseSchedulingScreenLayout'

export default CourseSchedulingScreen
